/**
 * Created by Andste on 2018/5/9.
 */

import Vue from 'vue'
import { Foundation } from '../../ui-utils'
import { api, domain } from '../../ui-domain'
import * as XLSX from 'xlsx'

export default {
  data() {
    return {
      // 图片上传API
      MixinUploadApi: api.base + '/uploaders',
      // 微信图片上传
      MixinWXUploadApi: api.zhibo + '/seller/live-video/media/upload',
      // 地区API
      MixinRegionApi: api.base + '/regions/@id/children',
      // 买家端PC域名
      MixinBuyerDomain: domain.buyer_pc,
      // 买家端WAP域名
      MixinBuyerWapDomain: domain.buyer_wap,
      // 日期选择器快捷选项
      MixinPickerShortcuts: [{
        text: '最近一周',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      }, {
        text: '最近三个月',
        onClick(picker) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }],
      // 是否首次激活过
      __activatedOnce: false,
      // 是否开启o2o
      isO2O: process.env.O2O
    }
  },
  computed: {
    /**
     * 缓存页面数组
     * @returns {default.computed.cachedViews|(function())|Array|*|getters.cachedViews}
     */
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    /**
     * 返回默认时间 + 5分钟
     * 用于日期时间选择器的默认时间
     * @returns {string}
     * @constructor
     */
    MixinDefaultTime() {
      const today = new Date()
      let hours = today.getHours()
      let minutes = today.getMinutes() + 5
      let seconds = today.getSeconds()
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes
      if (seconds < 10) seconds = '0' + seconds
      return hours + ':' + minutes + ':' + seconds
    }
  },
  activated() {
    if (!this.__isRouteViewComponent()) return
    const activatedHooks = this.$options.activated
    if (Array.isArray(activatedHooks) && activatedHooks.length > 1) return
    if (!this.__activatedOnce) {
      this.__activatedOnce = true
      return
    }
    if (!this.hasQueryConditions()) {
      if (typeof this.init === 'function') {
        this.init()
      } else if (typeof this.advancedSearchEvent === 'function') {
        this.advancedSearchEvent()
      }
    }
  },
  methods: {
    /** 路由级组件是否已激活一次 */
    __isRouteViewComponent() {
      return this.$vnode && this.$vnode.data && this.$vnode.data.routerView
    },
    hasQueryConditions() {
      const hasValidValue = value => {
        if (value === undefined || value === null || value === '') return false
        if (Array.isArray(value)) return value.length > 0
        if (typeof value === 'object') return Object.keys(value).some(key => hasValidValue(value[key]))
        return true
      }
      const queryObjects = ['advancedForm', 'searchForm', 'filterForm', 'queryForm', 'form']
      const queryArrays = ['timeArr', 'refundTimeArr', 'dateRange', 'rangeDate', 'dateArr', 'refundTimeArr']
      const queryBooleans = ['MyApplyChecked', 'onlyMyApplyChecked', 'MyApplyCheckedVisible']

      for (const key of queryObjects) {
        if (this[key] && Object.keys(this[key]).some(k => hasValidValue(this[key][k]))) {
          return true
        }
      }
      for (const key of queryArrays) {
        if (Array.isArray(this[key]) && this[key].length > 0) {
          return true
        }
      }
      for (const key of queryBooleans) {
        if (this[key]) {
          return true
        }
      }
      return false
    },
    /** 返回克隆后的对象 */
    MixinClone(obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    /** 用于修改单条表格数据后，set到tableData中 */
    MixinSetTableData(tableData, idName, id, response) {
      const { data } = tableData
      const index = data.findIndex(item => item[idName] === id)
      Vue.set(data, index, response)
    },
    /** 用于判断表单是否为空 */
    MixinRequired(message, trigger) {
      return { required: true, pattern: /^\S.*$/gi, message: message , trigger: trigger || 'blur' }
    },
    /** 用于判断文本域是否为空（允许换行符）- 只要不是全空白就行 */
    MixinTextareaRequired(message, trigger) {
      return { 
        required: true, 
        validator: (rule, value, callback) => {
          if (!value || value.trim() === '') {
            callback(new Error(message))
          } else {
            callback()
          }
        },
        trigger: trigger || 'blur' 
      }
    },
    /** 格式化金钱 */
    MixinFormatPrice(row, column, cellValue, index) {
      if (typeof cellValue !== 'number') return ''
      return '￥' + Foundation.formatPrice(cellValue)
    },
    /** 格式化时间戳 */
    MixinUnixToDate(row, column, cellValue, index) {
      return Foundation.unixToDate(cellValue)
    },
    /**
     * 导出Excel
     * @param json   要导出的json数据
     * @param name   要导出的文件名
     * @param type   要导出的数据类型
     * @constructor
     */
    MixinExportJosnToExcel(json, name = 'data', type = 'application/octet-stream') {
      let wb = { SheetNames: [], Sheets: {}, Props: { }}
      if (!Array.isArray(json)) json = [json]
      json.forEach(item => {
        wb.SheetNames.push(item.sheet_name)
        wb.Sheets[item.sheet_name] = XLSX.utils.json_to_sheet(item.sheet_values, item.sheet_options)
      })
      const wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
      let blob = new Blob([s2ab(XLSX.write(wb, wopts))], { type })
      let link = document.createElement('a')
      document.body.appendChild(link)
      link.style.display = 'none'
      link.href = window.URL.createObjectURL(blob)
      link.download = `${name}.xlsx`
      link.click()
      // 释放资源
      setTimeout(() => {
        URL.revokeObjectURL(link.href)
      }, 100)

      function s2ab(s) {
        if (typeof ArrayBuffer !== 'undefined') {
          const buf = new ArrayBuffer(s.length)
          const view = new Uint8Array(buf)
          for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
          return buf
        } else {
          const buf = new Array(s.length)
          for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
          return buf
        }
      }
    },
    // 筛选枚举类型
    filterCommType(type,arr){
      let list = arr.filter(ele=>ele.comm_type == type)
      // let aa = list.sort((a,b)=>{return !a.seq_no-b.seq_no})
      // console.log(aa)
      // console.log(aa.map(ele=>ele.comm_enum))
      return list.sort((a,b)=>{return a.seq_no-b.seq_no})
      // return arr.filter(ele=>ele.comm_type == type).map(item=>item.comm_enum)
    },
    //转base64
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file); //开始转
        reader.onload = function() {
          fileResult = reader.result;
        }; //转 失败
        reader.onerror = function(error) {
          reject(error);
        }; //转 结束  咱就 resolve 出去
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    //base64转流文件下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      //aLink.click()
      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },

    MixinImageJudge(str) {
      if(!str) return ''
      let index = str.lastIndexOf('.')
      let type = str.substring(index + 1)
      let arr = ['png', 'jpg','jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff']
      return arr.indexOf(type.toLowerCase()) !== -1
    },
    /**
     * 判断两个日期相差月份
     * @param {开始日期} time1 
     * @param {结束日期} time2 
     * @param {相差月份} m 
     * @returns 
     */
    completeDate (time1, time2, m) {
      if(!time1 || !time2 || !m){
        return
      }
      var diffyear = time2.getFullYear() - time1.getFullYear();
      var diffmonth = diffyear * 12 + time2.getMonth() - time1.getMonth();
      if (diffmonth < 0) {
        return false;
      }
    
      var diffDay = time2.getDate() - time1.getDate();
    
      if (diffmonth < m || (diffmonth == m && diffDay <= 0)) {
    
        if (diffmonth == m && diffDay == 0) {
          var timeA = time1.getHours() * 3600 + 60 * time1.getMinutes() + time1.getSeconds();
          var timeB = time2.getHours() * 3600 + 60 * time2.getMinutes() + time2.getSeconds();
          if (timeB - timeA > 0) {
            return false;
          }
        }
        return true;
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixin.js